import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoAnexo, TipoAnexoProps } from '../../interfaces/catalogos/TipoAnexoInterface';

export const TipoAnexo = () => {

    return new Promise<TipoAnexoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoAnexo/', token)
            .then( ({ data } : { data : TipoAnexoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoAnexo = () => {

    return new Promise<TipoAnexoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoAnexo/ObtenerTipoAnexo', token)
            .then( ({ data } : { data : TipoAnexoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoAnexo = ( params: TipoAnexoProps ) => {

    return new Promise<TipoAnexoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoAnexo/Actualizar', params, token)
            .then( ({ data } : { data : TipoAnexoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoAnexo } );
            });

        }

    });

}

export const AgregarTipoAnexo = ( params: TipoAnexoProps ) => {

    return new Promise<TipoAnexoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoAnexo/Agregar', params, token)
            .then( ({ data } : { data : TipoAnexoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoAnexo } );
            });

        }

    });

}
